import { Component } from '@angular/core';
import { WelcomeMessageComponent } from './welcome-message/welcome-message.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: `r1-compass-app-page-shell`,
    imports: [WelcomeMessageComponent, NgOptimizedImage],
    template: `
        <div id="login-page-content">
            <div id="login-forms">
                <!-- This yells that the base image is larger than needs be. Consider making a smaller version in general, or one plus this larger one and using ngSrcset -->
                <img ngSrc="assets/tfs-logo.png" width="311" height="79" alt="Thermo Fisher Scientific logo" />

                <ng-content />
            </div>
            <div id="welcome-message">
                <r1-compass-app-welcome-message [title]="welcomePageInfo.title" [subtitle]="welcomePageInfo.subtitle">
                    This application is part of the Compass platform supported by the Data Science COE. For access or
                    questions, please reach out following the guidance
                    <a
                        href="https://corpit-thermofisher.atlassian.net/wiki/spaces/DSP/pages/41591821/Getting+Help+and+Support"
                        target="_blank"
                        >here</a
                    >.
                </r1-compass-app-welcome-message>
            </div>
        </div>
    `,
    styleUrl: './page-shell.component.scss',
})
export class PageShellComponent {
    readonly welcomePageInfo = {
        title: 'Scout',
        subtitle: 'Compass Playmaker Application',
    } as const;
}
